<div class="authentication">
  <div class="auth-shell">
    <aside class="shell-right" aria-label="Branding">
      <div class="auth-hero" [class.is-dark]="themingService.theme === 'dark'">
        <app-mesh-gradient></app-mesh-gradient>
        <app-auth-hero-carousel [i18nPrefix]="heroCarouselI18nPrefix()" />
      </div>
    </aside>

    <div class="shell-left" aria-label="Authentication content">
      <div class="shell-top" aria-label="Brand and language">
        <img
          class="shell-logo"
          [src]="
            themingService.theme === 'dark' ? logoDarkSrc() : logoLightSrc()
          "
          alt="Catch"
          loading="lazy"
        />

        <div class="shell-top-actions">
          <div class="shell-theme">
            <ct-lib-dropdown
              [dropdown]="themeDropdown"
              [autowidth]="true"
              [alignment]="'right'"
              [closeOnClick]="true"
            >
              <button
                type="button"
                class="shell-language-trigger"
                [attr.aria-label]="themeTriggerAriaKey() | transloco"
              >
                @if (themingService.theme === 'dark') {
                  <fa-icon [icon]="icons.moon" size="lg"></fa-icon>
                } @else {
                  <fa-icon [icon]="icons.brightnessLow" size="lg"></fa-icon>
                }
                <span class="shell-language-label">
                  @if (themingService.theme === 'dark') {
                    {{ themeDarkKey() | transloco }}
                  } @else {
                    {{ themeLightKey() | transloco }}
                  }
                </span>
              </button>
            </ct-lib-dropdown>
            <ng-template #themeDropdown>
              <div class="shell-language-panel">
                <ul
                  class="shell-language-menu"
                  role="menu"
                  [attr.aria-label]="themeMenuLabelKey() | transloco"
                >
                  <li role="none">
                    <button
                      type="button"
                      class="shell-language-option shell-theme-option"
                      role="menuitemradio"
                      [attr.aria-checked]="themingService.mode === 'light'"
                      (click)="setAuthThemeMode('light')"
                    >
                      <span class="shell-theme-option-main">
                        <fa-icon [icon]="icons.brightnessLow" size="lg"></fa-icon>
                        <span>{{ themeLightKey() | transloco }}</span>
                      </span>
                      @if (themingService.mode === 'light') {
                        <span class="shell-language-dot" aria-hidden="true"></span>
                      }
                    </button>
                  </li>
                  <li role="none">
                    <button
                      type="button"
                      class="shell-language-option shell-theme-option"
                      role="menuitemradio"
                      [attr.aria-checked]="themingService.mode === 'dark'"
                      (click)="setAuthThemeMode('dark')"
                    >
                      <span class="shell-theme-option-main">
                        <fa-icon [icon]="icons.moon" size="lg"></fa-icon>
                        <span>{{ themeDarkKey() | transloco }}</span>
                      </span>
                      @if (themingService.mode === 'dark') {
                        <span class="shell-language-dot" aria-hidden="true"></span>
                      }
                    </button>
                  </li>
                  <li role="none">
                    <button
                      type="button"
                      class="shell-language-option shell-theme-option"
                      role="menuitemradio"
                      [attr.aria-checked]="themingService.mode === 'auto'"
                      (click)="setAuthThemeMode('auto')"
                    >
                      <span class="shell-theme-option-main">
                        <fa-icon [icon]="icons.magic" size="lg"></fa-icon>
                        <span>{{ themeSystemKey() | transloco }}</span>
                      </span>
                      @if (themingService.mode === 'auto') {
                        <span class="shell-language-dot" aria-hidden="true"></span>
                      }
                    </button>
                  </li>
                </ul>
              </div>
            </ng-template>
          </div>

          <div class="shell-language">
            <ct-lib-dropdown
              [dropdown]="languageDropdown"
              [autowidth]="true"
              [alignment]="'right'"
              [closeOnClick]="true"
            >
              <button
                type="button"
                class="shell-language-trigger"
                aria-label="Change language"
              >
                <fa-icon [icon]="icons.globe" size="lg"></fa-icon>
                <span class="shell-language-label">
                  {{ languageService.currentLanguage?.name ?? 'Language' }}
                </span>
              </button>
            </ct-lib-dropdown>
            <ng-template #languageDropdown>
              <div class="shell-language-panel">
                <ul class="shell-language-menu" role="menu" aria-label="Available languages">
                  @for (lang of languages; track lang.value) {
                    <li role="none">
                      <button
                        type="button"
                        class="shell-language-option"
                        role="menuitemradio"
                        [attr.aria-checked]="
                          languageService.currentLanguage?.value === lang.value
                        "
                        (click)="languageService.setLanguage(lang.value)"
                      >
                        <span class="shell-language-name">{{ lang.name }}</span>
                        @if (languageService.currentLanguage?.value === lang.value) {
                          <span class="shell-language-dot" aria-hidden="true"></span>
                        }
                      </button>
                    </li>
                  }
                </ul>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="shell-body">
        <div class="shell-body-inner">
          @if (maintenanceInfo(); as info) {
            <ct-lib-info-banner type="warning">
              <p>
                {{
                  maintenanceInfoKey()
                    | transloco: { date: info.date, time: info.time }
                }}
              </p>
            </ct-lib-info-banner>
          }
          <div class="shell-body-view">
            <router-outlet />
          </div>
        </div>
      </div>

      <div class="shell-meta" aria-label="Copyright and version">
        <p>Copyright &copy; catchHR {{ year() }}@if (version()) { | {{ version() }} }</p>
      </div>
    </div>
  </div>
</div>
